import actions from './filesActions'
import state from './filesState'
import getters from './filesGetters'
import mutations from './filesMutations'

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
